import AjaxService from '@/util/ajaxService.js';
import MessageService from '@/util/messageService.js';

export default {
  name: 'App',
  mixins: [],
  extends: {},
  components: {
  },
  props: [],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() { },
  mounted() {
    this.init();
  },
  updated() { },
  beforeDestroy() { },
  methods: {
    // 初始化
    init() {

      // 抓取現在連線的網址url
      const getUrlString = window.location.href;
      if (getUrlString.split('?')[1]) {

        // 取得?後面串的參數:shortUrl=XXXXXXXX&openExternalBrowser=1
        const allParams = getUrlString.split('?')[1];

        // 取得第一組短網址的參數:shortUrl=XXXXXXXX
        const shortUrl = allParams.split('&')[0];

        // 取得第一組短網址的參數值
        const url = shortUrl.split('=')[1];

        // 將url的八碼短網址送到後端取值
        AjaxService.post("/oasPromo/shortUrl/redirectPage", { url },
          successResp => {
            const result = successResp.restData;
            const targetUrl = result.url + '?promoCode=' + result.id;
            window.location.href = targetUrl;
          },
          errorResp => {
            MessageService.showError(errorResp.appMsg);
          }
        );

      }

    },
  },
};



// WEBPACK FOOTER //
// ./src/App.js